interface Testimonial {
  quote: string;
  author: string;
  role: string;
  company: string;
  outcome: string;
}

const testimonials: Testimonial[] = [
  {
    quote: "Since implementing StackMap BOS, we've experienced better coordination across teams and improved access to the information needed to make timely business decisions. It has become an important part of how we work.",
    author: "Folashayo Adekunle",
    role: "Chief Information Officer",
    company: "Dafcom Ventures",
    outcome: "Better cross-team coordination",
  },
  {
    quote: "One of the biggest advantages of StackMap BOS has been the ability to manage our workforce from a single platform. The visibility it provides across locations has improved coordination, reporting, and the overall efficiency of our HR operations.",
    author: "Elizabeth Onwuka",
    role: "HR & Admin",
    company: "The Hub Terminus Limited",
    outcome: "Multi-location HR efficiency",
  },
  {
    quote: "The tailored pricing model meant we only paid for what we actually needed. No bloated enterprise contracts — just the right modules for our 45-person team.",
    author: "Fatima Bello",
    role: "Managing Director",
    company: "ClearPath Consulting",
    outcome: "40% cost savings vs. previous tools",
  },
];

const metrics = [
  { value: "40%", label: "Average reduction in operational overhead" },
  { value: "6 weeks", label: "Typical enterprise deployment timeline" },
  { value: "94%", label: "Customer retention rate" },
  { value: "200+", label: "Organisations using StackMap" },
];

export default function SocialProof() {
  return (
    <section className="relative py-16 md:py-24 bg-graphite-950">
      <div className="section-padding">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
              Trusted by{" "}
              <span className="text-emerald-accent">Growing Organisations</span>
            </h2>
            <p className="text-base sm:text-lg text-silver-300 max-w-2xl mx-auto leading-relaxed">
              See how businesses across industries use StackMap to streamline operations and drive growth.
            </p>
          </div>

          {/* Metrics */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5 mb-12 md:mb-16">
            {metrics.map((metric) => (
              <div
                key={metric.label}
                className="glass-card p-5 md:p-6 flex flex-col items-center text-center"
              >
                <span className="text-2xl md:text-3xl font-bold text-emerald-accent mb-2">
                  {metric.value}
                </span>
                <span className="text-xs text-silver-400 leading-relaxed">{metric.label}</span>
              </div>
            ))}
          </div>

          {/* Testimonials */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {testimonials.map((t) => (
              <div
                key={t.author}
                className="glass-card p-6 md:p-7 flex flex-col"
              >
                {/* Quote icon */}
                <div className="mb-5">
                  <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-emerald-accent/10">
                    <i className="ri-double-quotes-l text-emerald-accent text-lg" />
                  </span>
                </div>

                <blockquote className="text-sm text-silver-300 leading-relaxed mb-6 flex-1">
                  &ldquo;{t.quote}&rdquo;
                </blockquote>

                {/* Outcome badge */}
                <div className="inline-flex items-center gap-1.5 self-start px-3 py-1.5 rounded-full bg-emerald-accent/10 border border-emerald-accent/20 mb-4">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-trophy-line text-emerald-accent text-xs" />
                  </span>
                  <span className="text-xs font-medium text-emerald-soft">{t.outcome}</span>
                </div>

                <div className="flex items-center gap-3 pt-4 border-t border-graphite-700/40">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-graphite-700 text-white text-xs font-bold">
                    {t.author.split(" ").map((n) => n[0]).join("")}
                  </div>
                  <div>
                    <p className="text-sm font-medium text-white">{t.author}</p>
                    <p className="text-xs text-silver-400">
                      {t.role}, {t.company}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}